/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Indicates the field to use for sorting the data:
 *   * START_DATE
 *   * DURATION
 *   * ENERGY
 *   * VOLUME
 *   * PROVIDER
 *   * PUMP_NUMBER
 *   * CARD_NUMBER
 *   * SUBSCRIPTION_NAME
 *   * STATION_NAME
 *   * SUBSERVICE_NAME
 */
export enum TransactionSortFieldName {
  START_DATE = 'START_DATE',
  DURATION = 'DURATION',
  ENERGY = 'ENERGY',
  VOLUME = 'VOLUME',
  PROVIDER = 'PROVIDER',
  PUMP_NUMBER = 'PUMP_NUMBER',
  CARD_NUMBER = 'CARD_NUMBER',
  SUBSCRIPTION_NAME = 'SUBSCRIPTION_NAME',
  STATION_NAME = 'STATION_NAME',
  SUBSERVICE_NAME = 'SUBSERVICE_NAME'
}
